import { UIField } from "../../../models/UIField";

export const CheckboxField = ({ model }: { model: UIField }) => {
  return (
    <div className="flex w-full h-full">
      <input disabled={model.disabled} className="w-4 h-4 m-auto" type="checkbox" checked={model.value} onChange={(e) => model.setValue(e.target.checked)} />
    </div>
  );
};
